export default __webpack_public_path__ + "static/media/magnifying_icon.63f211ad.svg";